var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.9072C0 4.88334 4.88334 0 10.9072 0C16.931 0 21.8144 4.88334 21.8144 10.9072C21.8144 16.931 16.931 21.8144 10.9072 21.8144C4.88334 21.8144 0 16.931 0 10.9072ZM10.9072 1.76873C5.86018 1.76873 1.76873 5.86018 1.76873 10.9072C1.76873 15.9542 5.86018 20.0456 10.9072 20.0456C15.9542 20.0456 20.0456 15.9542 20.0456 10.9072C20.0456 5.86018 15.9542 1.76873 10.9072 1.76873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94679 6.357C7.95944 5.34441 9.36089 4.71655 10.9073 4.71655C12.4537 4.71655 13.8552 5.34441 14.8678 6.35702C15.2131 6.70238 15.2131 7.26233 14.8678 7.6077C14.5224 7.95307 13.9624 7.95307 13.6171 7.6077C12.9226 6.91324 11.9658 6.48529 10.9073 6.48529C9.84882 6.48529 8.89196 6.91324 8.19743 7.60772C7.85205 7.95308 7.2921 7.95306 6.94675 7.60768C6.60139 7.2623 6.60141 6.70235 6.94679 6.357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4875 17.4875C17.8329 17.1422 18.3929 17.1422 18.7382 17.4875L23.741 22.4903C24.0863 22.8356 24.0863 23.3956 23.741 23.741C23.3956 24.0863 22.8356 24.0863 22.4903 23.741L17.4875 18.7382C17.1422 18.3929 17.1422 17.8329 17.4875 17.4875Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesBlack);
export default __webpack_public_path__ + "static/media/glasses-black.b3e706f5eef7f986647c056373055eeb.svg";
export { ForwardRef as ReactComponent };